if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      this.is_pdp_age = this.form.closest('.product-info');
      if (this.is_pdp_age) {
        this.shipAvail = this.is_pdp_age.querySelector('#shippingTimeframe .shipping-availability');
      }
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          if (this.shipAvail) {
            this.form.addEventListener('submit', this.checkShipping.bind(this));
          } else {
            this.form.addEventListener('submit', this.handleSubmit.bind(this));
          }
        }
      }
    }

    checkShipping(evt) {
      evt.preventDefault();

      if (this.is_pdp_age) {
        this.shipAvail = this.is_pdp_age.querySelector('#shippingTimeframe .shipping-availability');
      }

      let shipAvailText = this.shipAvail ? this.shipAvail.textContent.trim() : '';

      console.log('Shipping Availability Text:', shipAvailText);

      if (shipAvailText === 'UK' || shipAvailText === 'Netherlands') {
        let div = document.createElement('div');
        div.className = 'popup';
        div.setAttribute(
          'style',
          'position:fixed;inset:0;background:rgba(0,0,0,0.45);display:flex;align-items:center;justify-content:center;z-index:9999;padding:16px;'
        );

        const message =
          'The colour/size you selected will be transferred from our UK or Netherlands warehouse. Delivery is expected to be in late January - please confirm you wish to continue.';

        div.innerHTML = `
          <div class="popup-content"
               style="
                 background-color:#ffffff;
                 color:#333333;
                 padding:24px 24px 20px;
                 max-width:520px;
                 width:100%;
                 margin:0 auto;
                 border-radius:6px;
                 border-top:6px solid #d0021b; /* RED TOP BORDER */
                 box-shadow:0 10px 30px rgba(0,0,0,0.2);
                 text-align:left;
                 position:relative;
               ">
            <span class="popup-close-button"
                  style="
                    position:absolute;
                    top:12px;
                    right:16px;
                    font-size:22px;
                    cursor:pointer;
                    color:#333333;
                  ">&times;</span>

            <div style="display:flex;gap:12px;align-items:flex-start;margin-bottom:16px;">
              <div style="flex-shrink:0;margin-top:2px;">
                <!-- thin warning icon -->
                <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                  <path d="M12 3L3 20h18L12 3z"
                        fill="none"
                        stroke="#d0021b"
                        stroke-width="1.2"
                        stroke-linejoin="round" />
                  <line x1="12" y1="9" x2="12" y2="15"
                        stroke="#d0021b"
                        stroke-width="1.2"
                        stroke-linecap="round" />
                  <circle cx="12" cy="17.5" r="1.1" fill="#d0021b" />
                </svg>
              </div>

              <div>
                <h3 style="margin:0 0 6px;font-size:16px;font-weight:700;color:#000000;">
                  Delivery delay notice
                </h3>
                <p style="margin:0 0 12px;font-size:14px;line-height:1.5;color:#333333;">
                  ${message}
                </p>
              </div>
            </div>

            <div class="stock-button-wrapper"
                 style="display:flex;gap:12px;flex-wrap:wrap;justify-content:flex-end;margin-top:8px;">

              <button class="confirm-yes global-button global-button--primary"
                style="background:#ebad19 !important;border-color:#ebad19 !important;border-radius:6px;">
                Yes, add to cart
              </button>

              <button class="confirm-no global-button global-button--checkNo"
                style="border-radius:6px;">
                No, don't add to cart
              </button>
            </div>
          </div>
        `;

        document.body.appendChild(div);

        const closeButton = div.querySelector('.popup-close-button');
        const confirmYes = div.querySelector('.confirm-yes');
        const confirmNo = div.querySelector('.confirm-no');

        closeButton.addEventListener('click', () => div.remove());

        confirmYes.addEventListener('click', () => {
          this.handleSubmit(evt);
          setTimeout(() => div.remove(), 1000);
        });

        confirmNo.addEventListener('click', () => div.remove());

      } else {
        console.log('No popup triggered, submitting as normal.');
        this.handleSubmit(evt);
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            }
          }, 700);
        }

      } catch (error) {
        console.log(error);
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}